function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M84.055 80.343H19.658V15.944a3.713 3.713 0 10-7.426 0v68.111a3.713 3.713 0 003.713 3.713h68.11a3.713 3.713 0 100-7.425z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.459 74.584a3.714 3.714 0 004.891-1.912l8.46-19.315 11.486 8.097a3.711 3.711 0 005.614-1.726l9.962-26.482L81.127 23.22a3.714 3.714 0 00-4.078-6.205L60.784 27.702a3.71 3.71 0 00-1.436 1.795L50.65 52.618l-11.279-7.95a3.7 3.7 0 00-3.137-.542 3.708 3.708 0 00-2.403 2.087l-10.284 23.48a3.715 3.715 0 001.912 4.891z"
});

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 100 125"
  }, props), _ref, _ref2);
}

export default SvgChart;